import { handleSystemErrorReport } from '@mb/lib/utils';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { getUserAttributes } from '../helpers';
import { useAPICallStateHandler } from './customHooks';
import { definedTranslation } from '../../../pages/ProductSearch/i18n';
import { endpoints } from '../config';
import { setSnackbarInfo } from '../redux/sliceCreators/commonSlice';
import { SnackbarStatusEnum } from '../types';

// Post current user project to the server
const postCurrentUserProject = async (projectId: string) => {
  const userData = getUserAttributes();

  const response = await fetch(endpoints.postCurrentUserProject, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${userData.signin_token}`,
    },
    body: JSON.stringify({
      project_id: projectId,
    }),
  });

  return response.json();
};

export const useSwitchCurrentUserProject = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { state, setState } = useAPICallStateHandler();

  const labels = {
    success: intl?.formatMessage(
      definedTranslation.projectMessages.projectUpdated,
    ),
    error: intl?.formatMessage(
      definedTranslation.projectMessages.errorProjectSet,
    ),
  };

  const displayNotification = async (showSnackbar = true) => {
    try {
      if (showSnackbar) {
        dispatch(
          setSnackbarInfo({
            isOpen: true,
            message: labels.success,
            status: SnackbarStatusEnum.SUCCESS,
          }),
        );
      }
      setState({ isLoading: false });
    } catch (error) {
      dispatch(
        setSnackbarInfo({
          isOpen: true,
          message: error.message ?? labels.error,
          status: SnackbarStatusEnum.DANGER,
        }),
      );
      handleSystemErrorReport(
        `Error in useSwitchCurrentUserProject: ${error.message}`,
        'useSwitchCurrentUserProject',
      );
      setState({ isLoading: false, error });
    }
  };

  return { ...state, displayNotification };
};

export default useSwitchCurrentUserProject;
